import { getAuth } from "firebase/auth";
import { useIsAdminPaused } from "hooks/settings";
import { AdminMode, useSetAdminModeMutation } from "store/api/generatedApi";

export const useAdminMode = () => {
  const isAdminPaused = useIsAdminPaused();
  const [setAdminMode, { isLoading: isSavingAdminMode }] =
    useSetAdminModeMutation();

  const changeAdminMode = (mode: AdminMode) => {
    setAdminMode({ adminModeUpdate: { mode } })
      .unwrap()
      .then(() => getAuth().currentUser?.getIdToken(true))
      .catch(console.error);
  };

  return { isAdminPaused, isSavingAdminMode, changeAdminMode };
};
